module.exports = __webpack_public_path__ + "img/bilt&bac-seguros.8c3d5982.jpg";